import { createTheme } from "@mui/material/styles";

const NoborderTable = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "none",
          boxShadow: "none",
        },
      },
    },
    MuiTableContainer: { styleOverrides: { root: { border: "none", boxShadow: "none" } } },
    MuiTableCell: {
      styleOverrides: {
        root: { padding: 0, letterSpacing: 0, fontFamily: "red hat display" },
        head: {
          backgroundColor: "#F7F8FF !important",
          color: "#402899",
          fontWeight: 600,
          borderBottom: "1px solid #B5BFD0",
        },
      },
    },
    MuiDialog: {
      // styleOverrides: { paper: { borderRadius: "none" } },
      styleOverrides: { root: { borderRadius: "none" } },
    },
  },
});
export default NoborderTable;
